export default "__VITE_ASSET__C0mty5oJ__"